import { useLocalStorage } from "usehooks-ts"
import { backendProxy } from "./backendProxy";

const key = "conversation-client-id";
export const useClientId = () => {
    const [ clientId ] = useLocalStorage(key, () => {
        const newClientId = Date.now().toString();
        if (! localStorage.getItem(key)) {
            backendProxy.trackEvent('new-client', newClientId, {});
            localStorage.setItem(key, newClientId);
        }
        return newClientId;
    });
    return clientId;
}